const cta_newsletter = {
    title: "Subscribe to Weekly Scholarships Digest!",
    description: "Receive notifications about top undergraduate and graduate scholarships every week",
    link: "https://t.me/globstudy",
    actionText: "Subscribe"
}

export default cta_newsletter;